import { render, staticRenderFns } from "./agenda-item-file-attachment-modal-component.vue?vue&type=template&id=86bd8ac2&scoped=true"
import script from "./agenda-item-file-attachment-modal-component.ts?vue&type=script&lang=ts&external"
export * from "./agenda-item-file-attachment-modal-component.ts?vue&type=script&lang=ts&external"
import style0 from "./agenda-item-file-attachment-modal-component.scss?vue&type=style&index=0&id=86bd8ac2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bd8ac2",
  null
  
)

export default component.exports